<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Impressão Curva ABC de Vendas
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <ng-template [ngIf]="entityModal">
                        <div class="row">
                            <div class="col-12">
                                <div class="alert alert-info">
                                    <i class="fas fa-info" aria-hidden="true"></i> A impressão irá considerar a perspectiva selecionada, filtros e ordenação aplicados na consulta atual.
                                </div>
                            </div>
                        </div> 
                     
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="nomeImpressao" class="col-form-label">Nomeie a sua Impressão</label>
                                <input type="text" class="form-control" [(ngModel)]="entityModal.nomeImpressao" name="nomeImpressao" id="nomeImpressao" 
                                    #nomeImpressaoModel="ngModel">
                                <p class="form-text text-muted" style="margin-bottom:0px;">Nomeie a sua impressão para identificá-la facilmente.</p>                                                                          
                            </div>
                        </div>  
                    </ng-template>
                </form>
            </div>
            <div class="modal-footer">              
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-primary" (click)="print()" id="btnPrint">
                    <i class="fas fa-print"></i> Imprimir
                </button>                
            </div>            
        </div>
    </div>
</div>